import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';
import ExtractByTypename from 'graphql-client/ExtractByTypename';

import {AutomationInputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationInputFileGraphQL';
import {RunAutomationInputFileViewerQuery} from './__generated/RunAutomationInputFileViewerQuery';

type LiveAutomationInputFile = ExtractByTypename<
  RunAutomationInputFileViewerQuery['automationInputFile'],
  'AutomationInputFileNode'
>;

export default function getStatusForInputFileViewer(
  automationInputFile: AutomationInputFileGraphQL | LiveAutomationInputFile
): AutomationFileStatusGraphQL {
  const transformFileStatuses = automationInputFile.transformFiles?.map((file) => file?.status) ?? [];
  return resolveInputFileAndTransformsStatuses(automationInputFile.status, transformFileStatuses);
}

export function resolveInputFileAndTransformsStatuses(
  inputFileStatus: AutomationFileStatusGraphQL,
  transformFileStatuses: Array<AutomationFileStatusGraphQL | undefined>
): AutomationFileStatusGraphQL {
  if (transformFileStatuses.length && inputFileStatus === AutomationFileStatusGraphQL.succeeded) {
    const nonNullTransformStatuses = transformFileStatuses.filter((status) => status !== undefined);
    if (nonNullTransformStatuses.some((status) => status === AutomationFileStatusGraphQL.failed)) {
      return AutomationFileStatusGraphQL.failed;
    }
    return nonNullTransformStatuses.every((status) => status === AutomationFileStatusGraphQL.succeeded)
      ? AutomationFileStatusGraphQL.succeeded
      : AutomationFileStatusGraphQL.running;
  }
  return inputFileStatus;
}
